// ------------- Root Reducer -------------

// individual reducers
import menuReducer from './reducers/menus'
import introEndedReducer from './reducers/introEnded'
import paginationIndexReducer from './reducers/paginationIndex'

import { logger } from './middlewares'

// Default Global state of application at launch
export const initialState = {
  menus: menuReducer.initialState,
  introEnded: introEndedReducer.initialState,
  paginationIndex: paginationIndexReducer.initialState,
}

const rootReducer = (state, action) => {
  // Receiving previous state here
  const { menus, introEnded, paginationIndex } = state

  // Receiving current state here
  const currentState = {
    menus: menuReducer.reducer(menus, action),
    introEnded: introEndedReducer.reducer(introEnded, action),
    paginationIndex: paginationIndexReducer.reducer(paginationIndex, action),
  }

  // Middlewares
  logger(action, state, currentState)

  return currentState
}

export default rootReducer
